import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
    ViewEncapsulation,
} from '@angular/core';
import { DeltaViewComponent, SeparatorComponent } from '@interacta-shared/ui';
import { IconComponent } from '@interacta-shared/ui-icons';
import { ToastNotificationGroup } from '@interacta-shared/util-common';
import { iconByType } from '../../utils/toast-notification.utils';

@Component({
    imports: [DeltaViewComponent, IconComponent, SeparatorComponent],
    selector: 'interacta-toast-notification-group',
    templateUrl: './toast-notification-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    // None + unique class prefix (delta-view pattern): the indent must reach
    // the quill DOM rendered inside delta-view, out of emulated-scope reach.
    encapsulation: ViewEncapsulation.None,
    styles: `
        .toast-notification-group__first-message .ql-editor > p:first-child {
            text-indent: 24px;
        }
    `,
})
export class ToastNotificationGroupComponent {
    readonly group = input.required<ToastNotificationGroup>();
    readonly clamped = input(false);
    readonly overflowChanged = output<boolean>();

    readonly iconConfig = computed(() => iconByType[this.group().type]);
    readonly firstMessage = computed(() => this.group().messages[0]);
    readonly restMessages = computed(() => this.group().messages.slice(1));
}
